import { Event } from 'client/types/event';
import { List } from 'client/types/common';
import * as types from './types';

export function fetchEventsRequest(pageNumber?: number): types.FetchEventsRequest {
    return { type: types.FETCH_EVENTS_REQUEST, payload: pageNumber };
}

export function fetchEventsSuccess(data: List<Event>): types.FetchEventsSuccess {
    return { type: types.FETCH_EVENTS_SUCCESS, payload: data };
}

export function fetchEventsError(error: Error): types.FetchEventsError {
    return { type: types.FETCH_EVENTS_ERROR, payload: error };
}
